import { i18n as i18nInstance } from './i18n';
import translations from './translations.json';
import { errorFormatter } from './api/errorFormatter';
import { notificationRenderer } from './components/notificationRenderer';
import { formsErrorRenderer } from './components/formsErrorRenderer';


export * from './components/LanguageSelector';
export * from './components/ConnectedLanguageSelector';
export * from './components/TranslateComponent';

export * from './state/actions';

export const i18n = {
    i18n: i18nInstance,
    translations,

    API: {
        errorFormatter,
    },
    messaging: {
        notificationRenderer,
    },
    forms: {
        errorRenderer: formsErrorRenderer,
    },
};
